import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useUser = () => useQuery({ queryKey: [`user`], queryFn: async () => {
    const callback = await API.get(`/employees/me`)
    return callback?.data
}, staleTime: 60000, gcTime: 1000 * 60 * 30 })

export default useUser